import React, { useState, VFC } from 'react';
import { Box } from '@dxb-web-ui-framework/design-system';
import { useTransactionsProviderActions } from '../contexts/Transactions/hooks';
import { TableGrid } from '../../../content-composer/src/components/Generic/TableGrid';
import { ErrorAlert } from '../../../content-composer/src/components/Generic/ErrorAlert/ErrorAlert';
import {
  useNotificationsErrorState,
  useNotificationsLoadingState,
  useNotificationsTransactionsList,
} from '../contexts';
import { useTransactionsGridConfig } from './useTransactionGridConfig';
import { TransactionsWithDealerRateDrawer } from './TransactionsWithDealerRateDrawer';

const TransactionsTable: VFC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isLoadingTransactionList = useNotificationsLoadingState('isLoadingPendingAuthorizations');
  const transactionListError = useNotificationsErrorState('pendingAuthorizationsListError');
  const transactionList = useNotificationsTransactionsList();

  const { onSelectTransaction } = useTransactionsProviderActions();

  const onToggleDrawer = (orderId: number) => {
    if (typeof orderId === 'number') {
      onSelectTransaction(orderId);
    } else {
      onSelectTransaction(null);
    }
    setIsOpen(prev => !prev);
  };

  const gridConfig = useTransactionsGridConfig(onToggleDrawer);

  return (
    <>
      {transactionListError && (
        <Box mx={3} mt={2}>
          <ErrorAlert message={transactionListError.message} />
        </Box>
      )}
      {!transactionListError && (
        <TableGrid
          gridOptions={gridConfig.gridOptions}
          columnDefs={gridConfig.columnDefs}
          rowData={transactionList}
          hasSkeleton={isLoadingTransactionList}
          mobileListConfig={gridConfig.mobileListConfig}
          isRowSelected={gridConfig.isRowSelected}
        />
      )}
      <TransactionsWithDealerRateDrawer isOpen={isOpen} onToggleDrawer={onToggleDrawer} />
    </>
  );
};

export { TransactionsTable };
